import { useNavigate, useParams } from 'react-router-dom'
import { useContext } from 'react'
import { NavContext } from '../../../../context/global_context'
import SearchConnectorSection from '../../../../antd/dtcs/TATMappings/ConnectorMapping/SearchConnectorSection'
import DTCMappingSection from '../../../../antd/dtcs/TATMappings/ConnectorMapping/DTCMappingSection'
import { Flex, Row, Typography } from 'antd'
import EditDtcsMappingHeader from '../../../../antd/dtcs/TATMappings/EditDtcsMappingHeader'
import Button from '../../../../antd/common/Button'
import { LeftCircleOutlined, LeftSquareOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

const TatDtcMappings = () => {
  const intl = useIntl()
  let { vehicle } = useParams()
  const navigate = useNavigate()
  const [value] = useContext(NavContext)
  const searchInst = value.destination_only
    ? intl.formatMessage({ id: 'dtcs.connectorMapping.searchInstructionLeft' })
    : intl.formatMessage({ id: 'dtcs.connectorMapping.searchInstructionLeftStartEnd' })

  return (
    <>
      <div className="page edit-dtc-mappings">
        <Row className="title">
          <Flex vertical gap={16} style={{ width: '100%' }}>
            {value?.dtc_details?.length > 0 && (
              <>
                <Flex gap={16} align="center">
                  {/* <Button
                    className='back-button'
                    onClick={() =>
                      navigate(`/vehicles/${vehicle}/dtcs/listing`)
                    }
                  >
                    <LeftSquareOutlined/>
                  </Button> */}

                  <Typography.Title level={5}>
                    {intl.formatMessage({ id: 'dtcs.connectorMapping.selectedDtcCount' }, { count: value?.dtc_details?.length })}
                  </Typography.Title>
                </Flex>

                <EditDtcsMappingHeader
                  dtcs={value?.dtc_details}
                  vehicleSid={value?.vehicle}
                />
              </>
            )}
          </Flex>
        </Row>
        <Row className="body">
          <Flex
            align="flex-start"
            justify="space-evenly"
            className="col-container"
          >
            <SearchConnectorSection />
            
            <Flex className="col" gap={16}>
              <div className="col-header">&nbsp;</div>
              <div className="col-body">
                <div className="no-data">{searchInst}</div>
                <Button
                  onClick={(e) => navigate(`/vehicles/${vehicle}/dtcs/listing`)}
                >
                  {intl.formatMessage({ id: 'forms.cancel' })}
                </Button>
              </div>
            </Flex>

            <DTCMappingSection />
          </Flex>
        </Row>
      </div>
    </>
  )
}

export default TatDtcMappings
